
/**
 * Sprint Task
 * https://developerx.atlassian.net/browse/CS-5132
 *
 * Date Created : 13 Dec 2021       Created by   : Risman Abdilah
 * Date Updated : 14 Dec 2021       Updated by   : Risman Abdilah
 *
 * Version 1.0.1
 */

import Vue from "vue";
import filters from "@/filters";
import Component from "vue-class-component";
import { State } from "vuex-class";

import { JobFairEventModel } from "@/models/job.model";

@Component({
  filters,
})
export default class JobFairEventList extends Vue {
  /* VUEX */

  /* ACTIONS */

  /* STATE */
  @State("array_job_fair_event", { namespace: "job" })
  private array_job_fair_event: Array<JobFairEventModel>;

  /* INITIALIZATION */
  private dropdown_index = 0;

  /* METHODS */
  private clickDropdown(menu: number) {
    if (this.dropdown_index === menu) {
      this.dropdown_index = 0;
    } else {
      this.dropdown_index = menu;
    }
  }
}
